import { Component } from 'react'
import { connect } from 'react-redux'
import Bulletin from 'components/Bulletin'
import { fetchBulletin, resetBulletin } from './actions'
import { selectMessages, selectIsFetching, selectTotalCount, selectPage } from './selectors'

const DEFAULT_LIMIT = 20
const DEFAULT_PAGE = 1

class BulletinContainer extends Component {
  
  componentDidMount() {
    this.props.resetBulletin()
    this.props.fetchBulletin(DEFAULT_PAGE, DEFAULT_LIMIT)
  }
  fetchMoreBulletin = () => {
    const {  page, messages, totalCount } = this.props;
    if (messages.length < totalCount) {
      this.props.fetchBulletin(page, DEFAULT_LIMIT); // Fetch next page
    }
  };

  render() {
    const { messages, totalCount, isFetching, height } = this.props;
    const params = {
      messages,
      totalCount,
      isFetching,
      height, 
      fetchMoreBulletin: this.fetchMoreBulletin,
    };
    return <Bulletin {...params} />
  }
}

const mapStateToProps = state => ({
  messages: selectMessages(state),
  isFetching: selectIsFetching(state),
  totalCount: selectTotalCount(state),
  page: selectPage(state),
})

const mapDispatchToProps = dispatch => ({
  fetchBulletin: ( page, limit) =>
    dispatch(fetchBulletin.request(page, limit)),
  resetBulletin: () => dispatch(resetBulletin())
})

export default connect(mapStateToProps, mapDispatchToProps)(BulletinContainer)
